import { Component } from "react";
import { Link } from "react-router-dom";
import Cookies from 'universal-cookie';
import base64 from 'base-64';
import { translate } from "./../helpers/intl_helpers";
import { PublicClientApplication } from "@azure/msal-browser";
import { UserDetails } from "../UserDetails";
import { WEBSITE_URL, STATUS_SUCCESS } from "./../config/global_constants";
import { callBackendAPI, generateSource, cancelToken  } from '../helpers/common';

import logoIcon from '../assets/images/blended_cannon_logo.svg';

/** Azure SSO login configuration */
let webLoginURL =   WEBSITE_URL+"login";
let msalConfig = {
    auth: {
        clientId    :   process.env.REACT_APP_AZURE_AD_CLIENT_ID,
        authority   :   "https://login.microsoftonline.com/" + process.env.REACT_APP_AZURE_AD_TENANT,
        redirectUri :   webLoginURL,
        postLogoutRedirectUri :   WEBSITE_URL,
    },
    cache: {
        cacheLocation           :   "sessionStorage",
        storeAuthStateInCookie  :   false,
    },
    system: {
        loggerOptions: {
            logLevel: "info",
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
            },
        },
    },
};

// const msalInstance = new PublicClientApplication(msalConfig);

export default class Login extends Component {
    source;

    static contextType = UserDetails;

    constructor(props) {
        super(props);

        const cookies 	    =	new Cookies();
        const queryParams 	=	new URLSearchParams(this.props.location.search);
        if(queryParams.get('callbackUrl')){
            let callbackUrl = queryParams.get('callbackUrl');
            cookies.set('callbackUrl', base64.encode(callbackUrl), { path: "/" });
        }

        msalConfig.auth.redirectUri = webLoginURL;

        this.state = {
            errors: {},
            fields: {},
            submitted: false
        };

        this.msalInstance = new PublicClientApplication(msalConfig);
    }

    async componentDidMount() {
        await this.msalInstance.initialize();
        this.handleAzureRedirect();
    }

    componentWillUnmount(){
        cancelToken(this.source); // cancel the request
    }

    handleAzureRedirect = async () => {
        try {
            let response = await this.msalInstance.handleRedirectPromise();

            if(response && response.idToken && response.idToken !== ""){
                /** Generate source for cancel token */
                this.source = generateSource();

                window.showLoader();
                callBackendAPI([{ model: 'registration', method: 'ssoLogin', token: response.idToken }],this.source).then(response => {
                    window.hideLoader();

                    if (response.success && response.data[0].status === STATUS_SUCCESS) {
                        let resData = response.data[0];
                        let cookieUser = {
                            _id: resData.result._id,
                            full_name: resData.result.full_name,
                            first_name: resData.result.first_name,
                            last_name: resData.result.last_name,
                            email: resData.result.email,
                            mobile_number: resData.result.mobile_number,
                            department: resData.result.department,
                            location: resData.result.location,
                            slug: resData.result.slug,
                            role_id: resData.result.role_id,
                            profile_image: (resData.result.image) ? resData.result.image : "",
                            token: (resData.token) ? resData.token : "",
                            image_url: (resData.result.file_url) ? resData.result.file_url : "",
                            permission_level: (resData.result.permission_level) ? resData.result.permission_level : "",
                            login_with_sso: true,
                        };

                        const cookies   =   new Cookies();
                        let redirectUrl =   '/calendar';
                        try{
                            if(cookies.get('callbackUrl')){
                                redirectUrl = base64.decode(cookies.get('callbackUrl'));

                                /** Remove key */
                                cookies.remove("callbackUrl",{ path: '/' });
                            }
                        }catch(e){}

                        cookies.set('user_details', cookieUser, { path: "/" });
                        this.context.updateUserState(cookieUser, () => {
                            this.props.history.push(redirectUrl);
                        });
                    }
                }).catch(err => console.log(err));
            }
        } catch (error) {
            /** Generate source for cancel token */
            this.source = generateSource();

            /** Write logs */
            callBackendAPI([{ model: 'home', method: 'writeLogs', error : error.toString(), componentStack: "sso login"}],this.source,false).then(()=>{}).catch(err => console.log(err));
        }
    };

    loginWithAzure = async () => {
        try {
            this.msalInstance.loginRedirect({
                scopes: ["openid", "profile", "email"], // Add any other scopes needed
            });
        } catch (error) {
            console.error("Error opening login popup:", error);
        }
    };

    render() {
        return (
            <div className="login-page loginsso">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-6">
                            <div className="login-box text-center">
                                <figure>
                                    <img src={logoIcon}alt="Logo" width={300} height={180} />
                                </figure>
                                <div className="d-flex justify-content-between align-items-center flex-column-reverse flex-lg-row">
                                    <Link to="#" className="btn btn-fill w-100" onClick={() => this.loginWithAzure()} >
                                        {translate("login.sso_login")}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}